
<div class="flex">
  <label class="i-switch i-switch-sm ml-2 {{className}}">
    <input type="checkbox" [(ngModel)]="parseValue" name="{{name}}" (ngModelChange)="valueUpdated()" [disabled]="disabled ? disabled : null"/><i></i>
  </label>
  <div [innerHTML]="title"></div>
</div>